import * as React from "react";
import PageLayout from "../components/Shared/PageLayout";
import LeaderboardPage from "./profile";
import { EDPageLoader, grey } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";

const League = dynamic(() => import("../components/Pages/League/Public/League"), {
  suspense: false,
  ssr: false,
  loading: () => <EDPageLoader in={true}/>,
})
export default function RankingPage() {
  return <PageLayout justifyContent={"flex-start"} backgroundColor={grey("900")}>
    <League/>
  </PageLayout>
}

LeaderboardPage.metaData = {
  title: 'Eternal Dragons Universe - League'
}